import React from 'react';
import { useAppSelector } from 'redux/store';
import RatioGauge from "./RatioGauge";


const RatioGauge_Calculator = () => {
    const ratio = useAppSelector((state => state.user.ratio.Calculator));

    return (
        <RatioGauge ratio={ratio} />
    )
};

export default RatioGauge_Calculator;